//SET_EVENTDATA
import * as ActionTypes from "../ActionTypes";
import * as URL from "../API_URL";
 import {
  postRequest,
  getRequest
 } from "./index";

export const saveEvents = (payload) => {
  return postRequest(URL.SAVE_EVENTS, payload, ActionTypes.SET_EVENTDATA);
}

export const fetchEvents = (payload) => {
  return getRequest(URL.LOAD_EVENTS, ActionTypes.LOAD_EVENTS);
}
